import { UoaErrorsConfig } from '@uoa/error-pages';

export class AppErrorsConfig extends UoaErrorsConfig {
  constructor() {
    super();

    this.showErrorAsToast = true;
  }
}
